import IError from "../interfaces/IError";
import t from "./t";

export default function translateError(error: IError): string {
    return t(error.type, error.data);
}



// WEBPACK FOOTER //
// ./src/utils/translateError.ts